import { api } from '@/lib/api';
import type {
  IApiResponse,
  IUser,
  ICreateUserRequest,
  ISsoLoginListItem,
  UserRole,
} from '@skystone/shared';

export const userApi = {
  getAll: async (): Promise<IUser[]> => {
    const result = await api.get<IApiResponse<IUser[]>>('/users');
    return result.data;
  },

  create: async (user: ICreateUserRequest): Promise<IUser> => {
    const result = await api.post<IApiResponse<IUser>>('/users', user);
    return result.data;
  },

  updateRole: async (id: string, role: UserRole): Promise<IUser> => {
    const result = await api.patch<IApiResponse<IUser>>(`/users/${id}/role`, { role });
    return result.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  listSsoLogins: async (): Promise<ISsoLoginListItem[]> => {
    const result = await api.get<IApiResponse<ISsoLoginListItem[]>>('/users/sso-logins');
    return result.data;
  },
};
